import router from 'Router'
import i18n from '@/i18n'
import { networkErrorPage } from 'Router/helpers'

export const apiErrorHandling = (error) => {
  if (error.response?.status === 404) {
    router.push({
      name: '404-resource',
      params: { resource: i18n.t('ui.error_page.resource.template') },
    })
  } else {
    router.push(networkErrorPage)
  }
}
